import type {
  CreateTemplateV3Body,
  GetTemplatePagesWithRuleResponse,
  GridToTableMigrationRequest,
  InlineResponse2004,
  MultipleChoiceGroup,
  Template,
  TemplatePage,
} from '@ulysses-inc/harami_api_client'

export type MigrationSource = {
  template: Template
  pagesWithRule: GetTemplatePagesWithRuleResponse
  templateSpecificChoices: MultipleChoiceGroup[]
}

export type MigratedTemplateBody = Omit<
  CreateTemplateV3Body,
  'gridToTableMigration'
> & {
  gridToTableMigration: GridToTableMigrationRequest
}

export type EligibilityResult =
  | { eligible: true }
  | { eligible: false; reasons: string[] }

export type UuidMappings = {
  nodeUuids: Map<string, string>
}

export type ConvertedMigration = {
  pages: TemplatePage[]
  mappings: UuidMappings
}

export type ChoiceIdMapping = {
  groupIds: Map<number, number>
  choiceIds: Map<number, number>
}

export type MigrationWorkflowDependencies = {
  fetchSource: (templateId: number) => Promise<MigrationSource>
  createChoices: (groups: MultipleChoiceGroup[]) => Promise<ChoiceIdMapping>
  createTemplate: (body: MigratedTemplateBody) => Promise<InlineResponse2004>
}

export class MigrationDomainError extends Error {
  readonly reasons: string[]

  constructor(reasons: string[]) {
    super(reasons.join('\n'))
    this.name = 'MigrationDomainError'
    this.reasons = reasons
  }
}
